import Cookies from "js-cookie";
import LZString from "lz-string";

const accessTokenCookieKey = "sp_access_token";
const scopesCookieKey = "sp_access_token_scope";
const refreshTokenCookieKey = "sp_refresh_token";

const setCookies = (key, value, expiresIn = null) => {
  let expires = null;
  if (expiresIn) {
    expires = new Date(Date.now() + parseInt(expiresIn, 10) * 1000);
  }
  Cookies.set(key, LZString.compressToEncodedURIComponent(value), ( expires && { expires }));
};

const getCookies = (key) => {
  const cookieValue = Cookies.get(key);
  if (cookieValue) {
    return LZString.decompressFromEncodedURIComponent(cookieValue);
  }
  return null;
};

const removeAuthCookies = () => {
  Cookies.remove(accessTokenCookieKey);
  Cookies.remove(scopesCookieKey);
  Cookies.remove(refreshTokenCookieKey);
};

export {
  removeAuthCookies,
  setCookies,
  getCookies,
  accessTokenCookieKey,
  scopesCookieKey,
  refreshTokenCookieKey,
};
